import useSWR from 'swr';
import egg1 from '@/assets/images/egg_common.webp';
import egg3 from '@/assets/images/egg_mythic.webp';
import egg2 from '@/assets/images/egg_rate.webp';
import { CONSTANTS } from '@/constants';
import { Chest__factory } from '@/contracts';
import { useWalletAddress } from '@/hooks/useWalletAddress';
import { sharedProvider } from '@/utils/share-provider';

const DECIMAL = 1e18;

async function fetchBalance({ address }: { address?: string }) {
  if (!address) {
    throw new Error('Not found Address');
  }

  const url = CONSTANTS.SMASH_ADDRESS;
  if (!url) {
    throw new Error('Not found Address');
  }
  const provider = sharedProvider.get(CONSTANTS.RPC);

  const contract = Chest__factory.connect(url, provider);
  const data = await contract.batchBalanceOfEggs(address);

  if (!data) {
    return [
      { src: egg1, value: '0' },
      { src: egg2, value: '0' },
      { src: egg3, value: '0' },
    ];
  }

  const value1 = Math.floor(Number(data[0]) / DECIMAL);
  const value2 = Math.floor(Number(data[1]) / DECIMAL);
  const value3 = Math.floor(Number(data[2]) / DECIMAL);

  return [
    { src: egg1, value: String(value1) },
    { src: egg2, value: String(value2) },
    { src: egg3, value: String(value3) },
  ];
}
export function useBalance() {
  const address = useWalletAddress();

  const response = useSWR(
    { key: 'fetch-balance', address: address },
    fetchBalance,
    {
      dedupingInterval: 10000,
      fallbackData: [
        { src: egg1, value: '0' },
        { src: egg2, value: '0' },
        { src: egg3, value: '0' },
      ],
    },
  );

  return response;
}
